export enum StageState {
  BLOCKED = 'BLOCKED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  ACCEPTED = 'ACCEPTED'
}

export const TRANSLATE = {
  [StageState.IN_PROGRESS]: 'درجریان',
  [StageState.BLOCKED]: 'غیر فعال',
  [StageState.SUBMITTED]: 'منتظر تائید',
  [StageState.ACCEPTED]: 'تایید شده'
};
